module.exports = __webpack_public_path__ + "img/procrastinationthumb.1adbf61c.jpg";